import { combineReducers } from 'redux'
import versions from './versions'
import upgrades from './upgrades'

export default combineReducers({
  versions,
  upgrades
})



// WEBPACK FOOTER //
// ./reducers/source-upgrades/index.js